// extracted by mini-css-extract-plugin
export var bottom = "index-module--bottom--5puuO";
export var fakeHeader = "index-module--fake-header--y-Zvv";
export var fixed = "index-module--fixed--tG2Ln";
export var isTall = "index-module--is-tall--w0MjF";
export var kstWrap = "index-module--kst-wrap---CPNn";
export var top = "index-module--top--j5lmt";